import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArtistImageSliceData } from "../../redux/artistImageDataSlice";
import loading from "../../assets/loading.gif";
import { bannerLoader } from "../../redux/bannerImages";
import HeaderAgentTabs from "../headerAgentTabs";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import noFavImg from "../../assets/img/NoFav.png";
import NewArtistRibbon from "./searchPages/newArtistRibbon";
import { updateMessage, updateOpen } from "../../redux/message";
import { addFavoriteArtist, favoriteUpdatesOnOff, removeFavoriteArtist } from "../../AxiosFunctions/Axiosfunctionality";
import { AgentDataAPI } from "../../redux/agentSlice";
import Contact from "./contact";
import NonArtistHomeTabs from "./nonArtistHomeTabs";
import MyPopup from "../../components/myPopup/myPopup";

function Artists(props) {
  const { agentData } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const { artistImageDataSlice } = useSelector((state) => state);
  const [filterCond, setFilterCond] = useState(true);
  const [tempArtist, setTempArtist] = useState([]);
  const [filterHighlighted, setFilterHighlighted] = useState(null);
  const [activeTab, setActiveTab] = useState("featured");
  const getQueryParam = (param) => new URLSearchParams(location.search).get(param);
  const queryTab = getQueryParam("activeTab");
  const [allArtists, setAllArtists] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [favoriteUpdatesOn, setFavoriteUpdatesOn] = useState(false);
  const [showTutorialVideo, setShowTutorialVideo] = useState(false);
  const [tutorialVideoUrl, setTutorialVideoUrl] = useState("/assets/video/MYSHANNON_INTRO_ONLY.mp4");
  const history = useHistory();
  const [windowSize, setWindowSize] = useState(getWindowSize());

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    if (artistImageDataSlice.artistImages.length !== 0) {
      setAllArtists(artistImageDataSlice.artistImages);
    }
  }, [artistImageDataSlice.artistImages]);

  useEffect(() => {
    if (agentData?.favoriteArtists) {
      setFavorites(agentData.favoriteArtists);
    }
    if (agentData && agentData._id) {
      setFavoriteUpdatesOn(agentData.favoriteUpdatesOn || false);
    }
  }, [agentData]);

  useEffect(() => {
    if (location && location.search === "") {
      setActiveTab("");
    }
  }, [location]);

  const filterChange = (filter) => {
    if (filter === "A-Z") {
      let temp = [];
      setFilterCond(false);
      let tempImage = [...artistImageDataSlice.artistImages];
      temp = tempImage.sort((a, b) =>
        a.artistId.lastname
          .normalize()
          .localeCompare(b.artistId.lastname.normalize())
      );
      setTempArtist(temp);
      setFilterHighlighted(2);
    } else {
      setFilterHighlighted(1);
      setFilterCond(true);
    }
  };

  useEffect(() => {
    if (artistImageDataSlice.artistImages.length === 0) {
      dispatch(ArtistImageSliceData("kid"));
      dispatch(bannerLoader());
    }
  }, []);

  const updateTempArtist = (e) => {
    if (artistImageDataSlice.artistImages.length) {
      const searchvalue = e.toLowerCase();
      let temp = artistImageDataSlice.artistImages.filter(function (element) {
        let checker = false;
        if (
          element.artistId.firstname.toLowerCase().includes(searchvalue) ||
          element.artistId.lastname.toLowerCase().includes(searchvalue)
        ) {
          checker = true;
        }
        return checker;
      });
      setFilterHighlighted(null);
      setTempArtist(temp);
    }
  };

  useEffect(() => {
    localStorage.setItem("Category", "none");
    updateTempArtist(props.searchArtist);
  }, [artistImageDataSlice, props.searchArtist]);

  const handleContact = async () => {
    // dispatch(emptyCart());
  };

  const openVideoPopUp = () => {
    if (queryTab === "myHome") {
      setTutorialVideoUrl("/assets/video/MYSHANNON.mp4");
    }
    if (queryTab === "favoriteArtists") {
      setTutorialVideoUrl("/assets/video/MYFAVORITES.mp4");
    }
    setShowTutorialVideo(true);
  };

  const renderArtists = (anotherSet = undefined) => {
    let artistsToRender = [];
    if (props.searchArtist) {
      artistsToRender = tempArtist;
    } else if (activeTab === "myHome" && !anotherSet) {
      artistsToRender = allArtists.filter((val) =>
        !favorites.includes(val.artistId._id)
      );
    } else if (activeTab === "favoriteArtists") {
      artistsToRender = allArtists.filter((val) =>
        favorites.includes(val.artistId._id)
      );
    } else if (activeTab === "alphabetical") {
      artistsToRender = [...allArtists].sort((a, b) =>
        a.artistId.lastname
          .normalize()
          .localeCompare(b.artistId.lastname.normalize())
      );
    } else if(anotherSet === "tempArtist"){
      artistsToRender = tempArtist;
    } else if (anotherSet) {
      artistsToRender = allArtists.filter(
        (val) => favorites.includes(val.artistId._id)
      );
    } else {
      artistsToRender = allArtists; // default fallback
    }
    if (
      artistsToRender.length === 0 &&
      (activeTab === "favoriteArtists" || activeTab === "myHome")
    ) {
      return <img src={noFavImg} />;
    }

    return artistsToRender.map((val) => {
      const artistUpdates = agentData?.favUpdates?.find(
        (update) => update.artistId === val.artistId._id
      );

      let totalUpdates = artistUpdates
        ? artistUpdates.portfolio.length +
          artistUpdates.motions.length +
          artistUpdates.personalWorks.length +
          artistUpdates.properties.length +
          artistUpdates.publishedWorks.length +
          artistUpdates.awardPress.length
        : 0;

      if (artistUpdates?.bio === 1) {
        totalUpdates += 1;
      }

      return (
        <Link
          key={val.artistId._id}
          to={val.artistId.fullName}
          className="artistcard"
        >
          <img
            src={String(val.mainImage[0].subImage[0].path)}
            loading="lazy"
            alt=""
            className="image"
          />
          <div className="artistnamediv">
            <div className="artistnametext-v3">
              {val.artistId.firstname} {val.artistId.lastname}
              {favorites.includes(val.artistId._id) && totalUpdates > 0 && (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "16px",
                    height: "16px",
                    backgroundColor: "#d16a27",
                    color: "white",
                    fontSize: "8px",
                    fontWeight: "bold",
                    borderRadius: "50%",
                    position: "absolute",
                    right: "2px",
                  }}
                >
                  {totalUpdates}
                </span>
              )}
            </div>
          </div>
          <NewArtistRibbon date={val.artistId.date} />
          {agentData && agentData._id && (
            <div
              className={`favButtonHomeContainer ${
                favorites.includes(val.artistId._id) ? "d-flex" : ""
              }`}
            >
              <div
                onClick={(e) =>
                  favorites.includes(val.artistId._id)
                    ? handleDeleteFavorite(e, val.artistId._id)
                    : addtoFavorite(e, val.artistId._id)
                }
                className="favoriteButtonHomeDiv"
              >
                <img
                  src={
                    favorites.includes(val.artistId._id)
                      ? "/assets/images/redFavorite.svg"
                      : "/assets/images/favorite.svg"
                  }
                  alt="Favorite Icon"
                />
              </div>
            </div>
          )}
        </Link>
      );
    });
  };

  const addtoFavorite = async (e, artistId) => {
    e.preventDefault();
    try {
      dispatch(updateOpen(true));
      dispatch(updateMessage("Added to favorites!"));
      e.currentTarget.querySelector("img").src =
        "/assets/images/redFavorite.svg";
      setFavorites([...favorites, artistId]);
      await addFavoriteArtist({ _id: agentData?._id, artistId });
      await dispatch(AgentDataAPI({ _id: agentData?._id }));
    } catch (error) {
      console.log(error);
      dispatch(updateMessage("Failed to add to favorites!"));
    }
  };

  const handleDeleteFavorite = async (e, artistId) => {
    e.preventDefault();
    try {
      dispatch(updateOpen(true));
      dispatch(updateMessage("Successfully Unfavorited the Artist"));
      e.currentTarget.querySelector("img").src = "/assets/images/favorite.svg";
      setFavorites(favorites.filter((id) => id !== artistId));
      await removeFavoriteArtist({ _id: agentData?._id, artistId });
      await dispatch(AgentDataAPI({ _id: agentData?._id }));
    } catch (error) {
      console.error("Error removing favorite:", error);
    }
  };

  const handleCheckBox = async () => {
    try {
      const updatedValue = !favoriteUpdatesOn;

      // Optimistically update the UI
      setFavoriteUpdatesOn(updatedValue);

      // Update on the backend
      await favoriteUpdatesOnOff({
        agentId: agentData._id,
        favoriteUpdatesOn: updatedValue,
      });

      dispatch(updateOpen(true));
      dispatch(
        updateMessage(
          `Successfully ${updatedValue ? "enabled" : "disabled"} updates.`
        )
      );
      await dispatch(AgentDataAPI({ _id: agentData._id }));
    } catch (error) {
      console.error("Error updating favorite updates:", error);

      // Optional: Revert toggle on failure
      setFavoriteUpdatesOn(favoriteUpdatesOn); // Roll back state if needed
      dispatch(updateOpen(true));
      dispatch(updateMessage("Failed to update favorite updates."));
    }
  };

  return (
    <>
      <div class="sortingcont pt-0  me-0 ">
        <div className="_2cols" style={{ marginBottom: "0px" }}>
          <div className="div-block-4"/>
          <div className="d-flex">
            <HeaderAgentTabs agentData={agentData} activeTab={queryTab} setActiveTab={setActiveTab} handleContact={handleContact}/>
            <button
              class={
                filterHighlighted === 1
                  ? "filter-button sort-active w-inline-block  mt-0"
                  : filterHighlighted === 2
                  ? "filter-button w-inline-block  mt-0"
                  : "filter-button sort-active w-inline-block  mt-0"
              }
              style={{ marginLeft: "0px" }}
              onClick={() => filterChange("Default")}
            >
              <div>FEATURED</div>
            </button>
            <button
              class={
                filterHighlighted === 2
                  ? "filter-button sort-active w-inline-block mt-0"
                  : "filter-button w-inline-block mt-0"
              }
              className={
                activeTab === "alphabetical"
                  ? "filter-button sort-active w-inline-block mt-0"
                  : "filter-button w-inline-block mt-0"
              }
              onClick={() => filterChange("A-Z")}
            >
              <div style={{whiteSpace:"nowrap"}}>ALPHABETICAL A-Z</div>
            </button>
          </div>
        </div>
      </div>
      <div className="_2cols" style={{ clear: "both" }}>
        {props.children}
          {
            !queryTab && (<>
            <div id="w-node-a284be2a-4b91-3177-03eb-6614b24879c1-4bf2d022" className="_4cols-v2" style={
                props.searchArtist !== ""
                  ? { gridTemplateRows: "50px repeat(100,auto)" }
                  : {}}>
              {props.searchArtist ? (
                <h2 className="newsh2 h" style={{ gridColumn: "1/7" }}>
                  SEARCH RESULTS
                </h2>
              ) : null}
              {artistImageDataSlice.loading ? (
                <div style={{ position: "absolute", top: "50%", left: "50%" }}>
                  <img className="mb-3" alt="loading" src={loading} />
                </div>
              ) : artistImageDataSlice.artistImages &&
                props.searchArtist === "" &&
                filterCond ? (
                  renderArtists()
                ) : (
                  renderArtists("tempArtist")
              )}
            </div>
            </>)
          }
          {
            queryTab === "myHome" && 
            <div>
              <div
                className="d-flex"
                style={{ marginBottom: "10px", width: "98.4%" }}
              >
                <p
                  className="breadCrumbsActive"
                  onClick={() => history.push("./")}
                >
                  KSHome
                </p>
                <p style={{ marginLeft: "5px" }}>{">"}</p>
                <p className="breadCrumbs" style={{ marginLeft: "5px" }}>
                  My Shannon
                </p>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto 1fr",
                  alignItems: "center",
                  marginBottom: "40px",
                }}
              >
                <h2
                  className="newsh2 h"
                  style={{ marginBottom: "0px", color: "#ce651e" }}
                >
                  My Shannon
                </h2>
                <button
                  className={
                    showTutorialVideo
                      ? "filter-button-black sort-active w-inline-block mt-0"
                      : "filter-button-black w-inline-block mt-0"
                  }
                  onClick={openVideoPopUp}
                  style={{ justifySelf: "end", marginRight: "10px" }}
                >
                  Tutorial
                </button>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto 1fr",
                  marginBottom: "20px",
                }}
              >
                <h2 className="newsh2 h submenuItem" style={{ color: "black" }}>
                  My Favorites
                </h2>
                <div className="separatorSubCat"></div>
              </div>
              <div
                id="w-node-a284be2a-4b91-3177-03eb-6614b24879c1-4bf2d022"
                className="_4cols-v2"
                style={
                  props.searchArtist !== ""
                    ? {
                        gridTemplateRows:
                          windowSize.innerWidth > 600
                            ? "50px repeat(100,auto)"
                            : "",
                      }
                    : {}
                }
              >
                {props.searchArtist && (
                  <h2 className="newsh2 h" style={{ gridColumn: "1/7" }}>
                    SEARCH RESULTS
                  </h2>
                )}
                {artistImageDataSlice.loading && allArtists.length === 0 ? (
                  <div style={{ position: "absolute", top: "50%", left: "50%" }}>
                    <img className="mb-3" alt="loading" src={loading} />
                  </div>
                ) : (
                  renderArtists("myHome")
                )}
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto 1fr",
                  marginBottom: "20px",
                }}
              >
                <h2
                  className="newsh2 h submenuItem"
                  style={{ marginTop: "50px", color: "black" }}
                >
                  Additional Artists
                </h2>
                <div className="separatorSubCat"></div>
              </div>
              <div
                id="w-node-a284be2a-4b91-3177-03eb-6614b24879c1-4bf2d022"
                className="_4cols-v2"
                style={
                  props.searchArtist !== ""
                    ? {
                        gridTemplateRows:
                          windowSize.innerWidth > 600
                            ? "50px repeat(100,auto)"
                            : "",
                      }
                    : {}
                }
              >
                {props.searchArtist && (
                  <h2 className="newsh2 h" style={{ gridColumn: "1/7" }}>
                    SEARCH RESULTS
                  </h2>
                )}
                {artistImageDataSlice.loading && allArtists.length === 0 ? (
                  <div style={{ position: "absolute", top: "50%", left: "50%" }}>
                    <img className="mb-3" alt="loading" src={loading} />
                  </div>
                ) : (
                  renderArtists()
                )}
              </div>
            </div>
          }
          {
            queryTab === "favoriteArtists" && (
              <div>
                <div style={{ display: "flex" }}>
                  <div
                    className="d-flex"
                    style={{ marginBottom: "10px", width: "98.4%" }}
                  >
                    <p
                      className="breadCrumbsActive"
                      onClick={() => history.push("./")}
                    >
                      KSHome
                    </p>
                    <p style={{ marginLeft: "5px" }}>{">"}</p>
                    <p className="breadCrumbs" style={{ marginLeft: "5px" }}>
                      My Favorites
                    </p>
                  </div>
                  <div
                    className="ml-2 d-flex align-items-center justify-content-center"
                    style={{ width: "200px" }}
                  >
                    <span className="mr-2" style={{color:"#818181"}}>MyFavorites tracking:</span>
                    <label className="switchToggle">
                      <input
                        type="checkbox"
                        onChange={handleCheckBox}
                        checked={favoriteUpdatesOn}
                      />
                      <span className="sliderToggle roundToggle"></span>
                    </label>
                  </div>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "auto 1fr",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <h2
                    className="newsh2 h"
                    style={{ marginBottom: "0px", color: "#ce651e" }}
                  >
                    My Favorites
                  </h2>
                  <button
                    className={
                      showTutorialVideo
                        ? "filter-button-black sort-active w-inline-block mt-0"
                        : "filter-button-black w-inline-block mt-0"
                    }
                    onClick={openVideoPopUp}
                    style={{ justifySelf: "end", marginRight: "10px" }}
                  >
                    Tutorial
                  </button>
                </div>
                <div
                  id="w-node-a284be2a-4b91-3177-03eb-6614b24879c1-4bf2d022"
                  className="_4cols-v2"
                  style={
                    props.searchArtist !== ""
                      ? {
                          gridTemplateRows:
                            windowSize.innerWidth > 600
                              ? "50px repeat(100,auto)"
                              : "",
                        }
                      : {}
                  }
                >
                  {props.searchArtist && (
                    <h2 className="newsh2 h" style={{ gridColumn: "1/7" }}>
                      SEARCH RESULTS
                    </h2>
                  )}
                  {artistImageDataSlice.loading && allArtists.length === 0 ? (
                    <div style={{ position: "absolute", top: "50%", left: "50%" }}>
                      <img className="mb-3" alt="loading" src={loading} />
                    </div>
                  ) : (
                    renderArtists()
                  )}
                </div>
              </div>
            ) 
          }
          {
            (queryTab === "ideaBoard" || queryTab === "sharedIdeaBoard") && (
              <NonArtistHomeTabs
                activeTab={queryTab}
                agentData={agentData}
                setActiveTab={setActiveTab}
              />
            )
          }
          {
            queryTab === "contact" &&
              <div className="contactContainerHome">
                <Contact agentDetails={agentData} home={true} />
              </div>
          }
        </div>
      {showTutorialVideo && (
        <MyPopup
          BackClose
          CloseBtn
          onClose={() => setShowTutorialVideo(false)}
        >
          <video
            title="Tutorial"
            controls
            style={{
              width: "100%",
              maxHeight: "80vh",
              maxWidth: "80vw",
              objectFit: "contain",
              border: "none",
            }}
            src={tutorialVideoUrl}
            autoPlay
            type="video/mp4"
          >
            <source
              src={tutorialVideoUrl}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </MyPopup>
      )}
    </>
  );
}

export default Artists;
